import css from 'styled-jsx/css';
import { uppercase } from 'styles/typography/css-mixins';
import { sansSerif } from 'styles/css-constants';
import { warmGrays, sharedPalette } from 'styles/colors/constants';
import { MQ_MEDIUM, MQ_LARGE } from 'constants/mq';

export default css`
  .PostBylineBottom {
    width: calc(100% - 2rem);
    max-width: 696px;
    border-top: 1px solid black;
    padding: 1rem 0 2rem 0;
  }

  .PostBylineBottom--standard {
    display: flex;
    align-items: center;
  }

  .PostBylineBottom--withBio {
    align-items: flex-start;
  }

  .PostBylineBottom--standard .PostBylineBottom__text {
    display: flex;
    flex-direction: column;
    font-family: ${sansSerif};
    margin-left: 0.5rem;
  }

  .PostBylineBottom--standard .PostBylineBottom__authorName {
    font-weight: bold;
    color: black;
    margin-bottom: 0.125rem;
  }

  .PostBylineBottom--standard .PostBylineBottom__authorTitle {
    color: ${warmGrays[6]};
    font-size: var(--fontScaleNeg2);
    margin-bottom: 0.5rem;
    ${uppercase}
  }

  .PostBylineBottom--standard .PostBylineBottom__authorBio {
    color: #000;
    font-size: var(--fontScaleNeg1);
    line-height: 1.4;
  }

  :global(.PostBylineBottom--standard .PostBylineBottom__authorBio a) {
    color: inherit;
    border-bottom: 1px solid ${sharedPalette.watermelon};
  }

  .PostBylineBottom--standard .PostBylineBottom_authorFollow {
    color: #000;
    font-weight: bold;
    ${uppercase}
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;
  }

  .PostBylineBottom--standard .PostBylineBottom_authorFollow span {
    font-size: var(--fontScaleNeg2);
  }

  .PostBylineBottom--standard .PostBylineBottom_authorSocialLinks {
    display: flex;
    align-items: center;
    list-style: none;
  }

  .PostBylineBottom--standard .PostBylineBottom_authorSocialLinksItem {
    font-size: var(--fontScale3);
  }

  .PostBylineBottom--standard .PostBylineBottom_authorSocialLinksItem a {
    color: black;
    display: inline-block;
    padding: 0.5rem;
    margin-top: 0.25rem;
  }

  .PostBylineBottom--standard .PostBylineBottom_authorSocialLinksItem a:hover {
    color: ${sharedPalette.watermelon};
  }

  .PostBylineBottom__AMPImageWrap :global(img) {
    border-radius: 50%;
  }

  @media screen and ${MQ_MEDIUM} {
    .PostBylineBottom--standard .PostBylineBottom__authorBio {
      font-size: var(--fontScaleNeg2);
    }

    .PostBylineBottom--standard .PostBylineBottom_authorFollow span {
      font-size: var(--fontScaleNeg3);
    }

    .PostBylineBottom--standard .PostBylineBottom_authorSocialLinksItem {
      font-size: var(--fontScale1);
    }
  }

  @media screen and ${MQ_LARGE} {
    .PostBylineBottom--standard .PostBylineBottom__authorName {
      font-size: var(--fontScale1);
    }

    .PostBylineBottom--standard .PostBylineBottom__text {
      margin-left: 1rem;
    }

    .PostBylineBottom--standard .PostBylineBottom__authorTitle {
      font-size: var(--fontScaleNeg1);
    }

    .PostBylineBottom--standard .PostBylineBottom__authorBio {
      font-size: 14.22px;
    }

    .PostBylineBottom--standard .PostBylineBottom_authorFollow {
      margin-top: 0.5rem;
    }

    .PostBylineBottom--standard .PostBylineBottom_authorFollow span {
      font-size: var(--fontScaleNeg1);
      margin-right: 0.25rem;
    }

    .PostBylineBottom--standard .PostBylineBottom_authorSocialLinksItem a {
      padding: 0.25rem;
    }
  }
`;
